import { put, takeEvery } from "redux-saga/effects";
import { getAxiosHeaders, getService } from "../../library/RestAPI";
import {
  GET_COMPLIANCE_INITIAL_DATA,
  COMPLIANCE_LOADER,
  SET_COMPLIANCE_INITIAL_DATA,
  GET_COMPLIANCE_STATE_DATA,
  SET_COMPLIANCE_STATE_DATA,
} from "./complianceConstants";
import { GET_COMPLIANCE_INITIAL_DATA_URL, GET_COMPLIANCE_STATE_DATA_URL } from "../../../src/redux/constants/constants";

function* getComplianceInitialData() {
  try {
    yield put({
      type: COMPLIANCE_LOADER,
      payload: { complianceLoader: true },
    });
    const res = yield getService({
      method: "GET",
      url: GET_COMPLIANCE_INITIAL_DATA_URL,
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      let stateList = [];
      const tooltipMap = {};
      yield put({
        type: COMPLIANCE_LOADER,
        payload: { complianceLoader: false },
      });
      if (res.data.activeStates && res.data.activeStates.length > 0) {
        res.data.activeStates.forEach((stateObj) => {
          stateList.push(stateObj.state);
          const stateName = stateObj.state;
          let stateColor = 'green';
          const total = stateObj.statuses.NO + stateObj.statuses.YES + stateObj.statuses.UNKNOWN;
          if (total === stateObj.statuses.YES) {
            stateColor = 'green';
          } else if (total === stateObj.statuses.NO) {
            stateColor = 'red';
          } else if (total === stateObj.statuses.UNKNOWN) {
            stateColor = 'gray';
          } else {
            stateColor = 'yellow';
          }
          const stateStoreObj = {
            no: (stateObj.statuses.NO / total) * 100,
            yes: (stateObj.statuses.YES / total) * 100,
            unknown: (stateObj.statuses.UNKNOWN / total) * 100,
            total: total,
            compliantColor: stateColor,
            percentage: ((stateObj.statuses.YES / total) * 100).toFixed(2),
            lastUpdate: stateObj.lastUpdated,

          };
          tooltipMap[stateName] = stateStoreObj;
        });
      }
      yield put({
        type: SET_COMPLIANCE_INITIAL_DATA,
        payload: { stateList: stateList, tooltipMap: tooltipMap, complianceInitialData: { heading: res.data.heading, subHeading: res.data.subHeading } },
      });
    } else {
      yield put({
        type: COMPLIANCE_LOADER,
        payload: { complianceLoader: false },
      });
      yield put({
        type: SET_COMPLIANCE_INITIAL_DATA,
        payload: { stateList: [], tooltipMap: {}, complianceInitialData: null },
      });
    }
  } catch (error) {
    yield put({
      type: COMPLIANCE_LOADER,
      payload: { complianceLoader: false },
    });
    yield put({
      type: SET_COMPLIANCE_INITIAL_DATA,
      payload: { stateList: [], tooltipMap: {}, complianceInitialData: null },
    });
  }
}

function* getComplianceStateData(action) {
  try {
    yield put({
      type: COMPLIANCE_LOADER,
      payload: { complianceLoader: true },
    });
    const res = yield getService({
      method: "GET",
      url: GET_COMPLIANCE_STATE_DATA_URL(action.payload.selectedSite.name),
      headers: getAxiosHeaders(true),
    });
    if (res && res.status === 200 && res.data) {
      yield put({
        type: COMPLIANCE_LOADER,
        payload: { complianceLoader: false },
      });
      yield put({
        type: SET_COMPLIANCE_STATE_DATA,
        payload: { complianceStateData: res.data },
      });
    } else {
      yield put({
        type: COMPLIANCE_LOADER,
        payload: { complianceLoader: false },
      });
      yield put({
        type: SET_COMPLIANCE_STATE_DATA,
        payload: { complianceStateData: null },
      });
    }
  } catch (error) {
    yield put({
      type: COMPLIANCE_LOADER,
      payload: { complianceLoader: false },
    });
    yield put({
      type: SET_COMPLIANCE_STATE_DATA,
      payload: { complianceStateData: null },
    });
  }
}

function* ComplianceSaga() {
  yield takeEvery(GET_COMPLIANCE_INITIAL_DATA, getComplianceInitialData);
  yield takeEvery(GET_COMPLIANCE_STATE_DATA, getComplianceStateData);
}
export default ComplianceSaga;